(() => {
  try {
    const getCurrentREF = async () => {
      const urlParams = new URLSearchParams(window.location.search);

      const fallbackREF = sessionStorage.getItem("404_PATH")?.split("/")?.at(1);
      sessionStorage.removeItem("404_PATH");
      if (fallbackREF?.length) {
        return fallbackREF;
      }
      

      const paramREF = urlParams.get("ref");
      if (paramREF) {
        localStorage.setItem("CURRENT_SITE", paramREF);
        await waitForBackend();
        const distributor = await getPartnerBySite(paramREF);
        console.log("distributor", distributor);
        sessionStorage.setItem(
          `CACHE-${distributor.site_name}`,
          JSON.stringify(distributor)
        );
        return paramREF;
      }

      const localREF = localStorage.getItem("CURRENT_SITE");
      if (localREF) return localREF;

      return null;
    };

    const getPreferredREF = async () => {
      console.log("getPreferredREF");
      const sessionREF = sessionStorage.getItem("PREFERRED_SITE");
      if (sessionREF) return sessionREF;

      await waitForBackend();
      const distributor = await window.backend.getPreferredDistributor();
      console.log("distributor", distributor);
      if (distributor?.site_name) {
        sessionStorage.setItem("PREFERRED_SITE", distributor.site_name);
        sessionStorage.setItem(
          `CACHE-${distributor.site_name}`,
          JSON.stringify(distributor)
        );

        return distributor.site_name;
      }

      return null;
    };

    const loadTrackingInfo = () => {
      if (!sessionStorage.getItem("TRACKING_LANDING_URL")) {
        sessionStorage.setItem("TRACKING_LANDING_URL", window.location.href);
      }

      if (!sessionStorage.getItem("TRACKING_REFERRER") && document.referrer) {
        sessionStorage.setItem("TRACKING_REFERRER", document.referrer);
      }
    };

    function updateUrlREF(ref) {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set("ref", ref.toLowerCase());

      // Preserve the hash value if it exists
      const hashValue = window.location.hash;

      // Update URL while maintaining the hash
      window.history.replaceState(
        {},
        "",
        window.location.pathname + "?" + urlParams.toString() + hashValue
      );
    }

    async function handleREFMismatch(currentREF, preferredREF) {
      await waitForBackend();
      const currentPartner = await getPartnerBySite(currentREF);
      const preferredPartner = await getPartnerBySite(preferredREF);

      if (!(currentPartner && preferredPartner)) return;

      document.dispatchEvent(
        new CustomEvent("theme:partner:mismatch", {
          detail: { current: currentPartner, preferred: preferredPartner },
        })
      );
    }

    const getPartnerBySite = async (site_name) => {
      const cachedPartner = sessionStorage.getItem(`CACHE-${site_name}`);
      if (cachedPartner) return JSON.parse(cachedPartner);

      return window.backend.getDistrbutorBySiteName(site_name);
    };

    async function handlePartnerResolution(currentREF, preferredREF) {
      console.log("handlePartnerResolution");
      const currentOrPreferredREF = currentREF || preferredREF;
      if (!currentOrPreferredREF) return;

      await waitForBackend();
      const partner = await getPartnerBySite(currentREF || preferredREF);
      if (!partner?.site_name) return;

      updateUrlREF(partner.site_name);

      localStorage.setItem("CURRENT_SITE", partner.site_name);

      window.partner = partner;

      document.dispatchEvent(
        new CustomEvent("theme:partner:render", { detail: { partner } })
      );
    }

    const waitForBackend = () => {
      return new Promise((resolve) => {
        if (window.backend) {
          resolve();
        } else {
          const checkBackend = () => {
            if (window.backend) {
              resolve();
            } else {
              setTimeout(checkBackend, 50);
            }
          };
          checkBackend();
        }
      });
    };

    document.addEventListener("DOMContentLoaded", async () => {
      loadTrackingInfo();
      const currentREF = await getCurrentREF();
      const preferredREF = await getPreferredREF();

      // if currentREF is set and preferredREF is null, set preferredREF to currentREF
      if (currentREF && preferredREF === null) {
        sessionStorage.setItem("PREFERRED_SITE", currentREF);
        if (window.customer) {
          await waitForBackend();
          await window.backend.setDistributor(currentREF);
        }
      }

      console.log("currentREF", currentREF);
      console.log("preferredREF", preferredREF);

      // Async handling
      if (window?.customer && window.customer?.isPartner) {
        updateUrlREF(window.customer.site_name);
        localStorage.setItem("CURRENT_SITE", window.customer.site_name);
      } else {
        const isDifferentREF =
          currentREF && preferredREF && currentREF !== preferredREF;
        console.log("isDifferentREF", isDifferentREF);
        if (isDifferentREF) {
          await handleREFMismatch(currentREF, preferredREF);
        }
      }

      await handlePartnerResolution(currentREF, preferredREF);
    });
  } catch (e) {
    console.error(e);
  }
})();
